<template>
  <div class="panel panel-default panel-fill">
    <div class="panel-heading panel-heading-underline">
      <h3 class="panel-title">
        {{ trans("examination.imagesHeadline") }}
        <info-popup
          v-if="!MEDIA_PRODUCTS.includes(product.toLowerCase())"
          :text-content="getInfoPopupText()"
        />
      </h3>
    </div>
    <div class="panel-body">
      <media-gallery
        :images="images"
        :data-image-metadata="dataImageMetadata"
        :product-type="productType"
        :case-id="caseId"
        :use-column="false"
        :is-loading="false"
      >
      </media-gallery>
    </div>
  </div>
</template>

<script>
import MediaGallery from "./MediaGallery.vue";
import InfoPopup from "../../Utils/InfoPopup.vue";

import { PRODUCTS } from "../../../helpers/definitions";
import { infoPopupText } from "../../../helpers/misc";

export default {
  components: {
    MediaGallery,
    InfoPopup,
  },
  props: {
    images: {},
    dataImageMetadata: Object,
    product: String,
    caseId: Number,
  },
  data: function () {
    return {
      PRODUCTS: PRODUCTS,
      MEDIA_PRODUCTS: [
        PRODUCTS.CAPTURE.toLowerCase(),
        PRODUCTS.PHOTO.toLowerCase(),
        PRODUCTS.PHOTO_UK.toLowerCase(),
      ],
    };
  },
  methods: {
    getInfoPopupText: function () {
      return Object.values(this.images)
        .map((image) => `${this.trans("infoText." + image.type)}`)
        .join("<br />");
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  min-height: 200px;
}
</style>
